import { connect } from 'react-redux';

import Component from './AssessmentChecklist.component';
import { initCheckList } from '../+store/assessementChecklist/assessementChecklist.actions';

const mapStateToProps = (state) => ({
  loading: !!state.modules.Assessments.assessementCheckList.loadingMsg,
  rawCheckList: state.modules.Assessments.assessementCheckList.rawCheckList,
  profile: state.modules.Auth.auth.profile,
});

const mapDispatchToProps = (dispatch) => ({
  initChecklist: (profile) => {
    dispatch(initCheckList(profile));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
